import { useMemo } from 'react'

import { distanceFormats } from '../../../../formats'
import { form } from '../../formState'
import { useTexts } from './hooks/useTexts'

export function DistanceFormat() {
  const texts = useTexts()

  const options = useMemo(
    () =>
      Object.keys(distanceFormats).map(value => ({
        value,
        label: texts.distanceFormatValue(value as uui.domain.DistanceFormat),
      })),
    [texts],
  )

  return (
    <form.RadioGroup
      validateOn="blur change"
      options={options}
      testId="distanceFormat"
      label={texts.distanceFormat}
      name="distanceFormat"
    />
  )
}
